import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-link"
export default class extends Controller {
  static targets = ["text"]
  static values = { url: String }

  copy(event) {
    event.preventDefault()
    
    // Use the Clipboard API to copy the URL
    navigator.clipboard.writeText(this.urlValue).then(() => {
      // Update button text to show feedback
      const originalText = this.textTarget.textContent
      this.textTarget.textContent = "Copied!"
      
      // Reset after 2 seconds
      setTimeout(() => {
        this.textTarget.textContent = originalText
      }, 2000)
    }).catch((err) => {
      console.error('Failed to copy: ', err)
      // Fallback for browsers that don't support Clipboard API
      this.fallbackCopy()
    })
  }

  fallbackCopy() {
    // Create a temporary input element
    const tempInput = document.createElement('input')
    tempInput.value = this.urlValue
    document.body.appendChild(tempInput)
    tempInput.select()
    
    try {
      document.execCommand('copy')
      const originalText = this.textTarget.textContent
      this.textTarget.textContent = "Copied!"
      
      setTimeout(() => {
        this.textTarget.textContent = originalText
      }, 2000)
    } catch (err) {
      console.error('Fallback copy failed: ', err)
    } finally {
      document.body.removeChild(tempInput)
    }
  }
}